/* eslint-disable react-hooks/exhaustive-deps */
import {
  exitEditWidgetMode,
  saveWidget,
  saveWidgetCustomerConfig,
  selectMetricIndex,
} from 'actions/dashboardEdit';
import FilterPills from 'components/EnvelopeList/FilterPills';
import LoadingIndicator from 'components/LoadingIndicator';
import { widgetNameMap } from 'constants/dashboard';
import DashboardEditFiltersTreeContext, {
  DashboardEditFiltersTreeProvider,
} from 'contexts/DashboardEditFiltersTreeContext';
import useAddDashboardEditTreeToStore from 'hooks/envelopes/useAddDashboardEditTreeToStore';
import moment from 'moment-timezone';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getSaveCustomerLoading } from 'selectors/auth';
import { getUpsertDashboardLoading } from 'selectors/dashboard';
import { getDashboardState, getTree } from 'selectors/dashboardEdit';
import { useSelector } from 'store';
import { RouteParams } from 'types';
import { getAllFieldsValuesWithLabels, getNavParamsFromFilters } from 'utils/parserTree';
import GroupOptionsMenu from './GroupOptionsMenu';

const ReviewWidgetDashboardEditHeader: React.FC = () => {
  const dispatch = useDispatch();
  const { activeUuid } = useParams<{ activeUuid: string }>();

  const dashboardState = useSelector(getDashboardState(activeUuid || ''));

  // @ts-ignore
  const filterSearchBar = dashboardState.widgets[0].filters_search[0] || '';
  useAddDashboardEditTreeToStore(filterSearchBar, 0);
  const treeBar = useSelector((state) => getTree(state, 0));
  const treeBarParams = getAllFieldsValuesWithLabels(treeBar);
  let navParamsBar: RouteParams = {};
  navParamsBar = getNavParamsFromFilters(filterSearchBar, navParamsBar);

  // @ts-ignore
  const filterSearchLine = dashboardState.widgets[0].filters_search[1] || '';
  useAddDashboardEditTreeToStore(filterSearchLine, 1);
  const treeLine = useSelector((state) => getTree(state, 1));
  const treeLineParams = getAllFieldsValuesWithLabels(treeLine);
  let navParamsLine: RouteParams = {};
  navParamsLine = getNavParamsFromFilters(filterSearchLine, navParamsLine);

  const customerLoading = useSelector(getSaveCustomerLoading);
  const dashboardLoading = useSelector(getUpsertDashboardLoading);
  const loading = customerLoading || dashboardLoading;

  if (dashboardState.primary_timezone) {
    moment.tz.setDefault(dashboardState.primary_timezone);
  }

  const widget = dashboardState.widgets[0];

  useEffect(
    () => () => {
      dispatch(exitEditWidgetMode());
    },
    []
  );

  useEffect(() => {
    dispatch(selectMetricIndex(0));
  }, [dispatch]);

  const handleSave = (): void => {
    if (activeUuid) {
      dispatch(saveWidget({ multimetric: true }));
    } else {
      dispatch(saveWidgetCustomerConfig({ multimetric: true }));
    }
  };

  const handleCancel = (): void => {
    dispatch(exitEditWidgetMode());
  };

  const handleChangeMetric = (e: React.ChangeEvent<HTMLInputElement>): void => {
    dispatch(selectMetricIndex(Number.parseInt(e.target.value, 10)));
  };

  const renderFilterPills = (): JSX.Element | null => (
    <div className="flex flex-col gap-2">
      {treeBar && (
        <DashboardEditFiltersTreeProvider propMetricIndex={0}>
          <div className="flex flex-row gap-2">
            <label
              htmlFor="radio-0"
              className="h-6 flex flex-row items-center gap-2 text-body whitespace-no-wrap"
            >
              <input
                type="radio"
                id="radio-0"
                name="metric"
                value={0}
                className="input-radio"
                defaultChecked
                onChange={handleChangeMetric}
              />
              <span>Bar Chart</span>
            </label>

            <FilterPills
              propParams={navParamsBar}
              treePropsParams={treeBarParams}
              allowDelete
              envelopesPage
              customTree={treeBar}
              showAllFilters
              filtersModified
              treeContext={DashboardEditFiltersTreeContext}
            />
          </div>
        </DashboardEditFiltersTreeProvider>
      )}
      {treeLine && (
        <DashboardEditFiltersTreeProvider propMetricIndex={1}>
          <div className="flex flex-row gap-2">
            <label
              htmlFor="radio-1"
              className="h-6 flex flex-row items-center gap-2 text-body whitespace-no-wrap"
            >
              <input
                type="radio"
                id="radio-1"
                name="metric"
                value={1}
                className="input-radio"
                aria-hidden
                onChange={handleChangeMetric}
              />
              <span>Line Chart</span>
            </label>
            <FilterPills
              propParams={navParamsLine}
              treePropsParams={treeLineParams}
              allowDelete
              envelopesPage
              customTree={treeLine}
              showAllFilters
              filtersModified
              treeContext={DashboardEditFiltersTreeContext}
            />
          </div>
        </DashboardEditFiltersTreeProvider>
      )}
    </div>
  );

  return (
    <div className="pl-10 pr-6 pt-7 pb-4 flex flex-col bg-white">
      <div className="flex flex-row justify-between">
        <span className="text-heading-1">
          {widgetNameMap[widget.widget] || widget.title || widget.export_label || ''} Widget
        </span>
        <div className="flex flex-row gap-2">
          <button
            type="button"
            className="button button--secondary w-37 h-8 justify-center"
            onClick={handleCancel}
          >
            <span className="font-bold">Cancel</span>
          </button>
          <button
            type="button"
            className="button button--primary w-37 h-8 justify-center"
            onClick={handleSave}
          >
            {loading ? <LoadingIndicator size="5" /> : 'Save'}
          </button>
        </div>
      </div>
      <div className="flex flex-col gap-1">
        <span className="font-bold">Search Query</span>
        <span className="">
          Options in the Chart and Table facets are detrermined by this query
        </span>
        <div className="flex flex-row">
          <div className="flex flex-1">{renderFilterPills()}</div>
          <div className="w-23">
            <DashboardEditFiltersTreeProvider>
              <GroupOptionsMenu treeContext={DashboardEditFiltersTreeContext} />
            </DashboardEditFiltersTreeProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewWidgetDashboardEditHeader;
